import * as requiredUrls from '../../../../utils/appointment.url'
export default {
  data: function () {
    return {
      reserveDesc: '', // 预约须知
      readCountdown: 5, // 按钮倒计时
      btnDisabled: true, // 置灰“阅读”按钮状态
    }
  },
  components: {

  },
  methods: {
    // 跳回预约选择大厅页
    goIndex() {
      sessionStorage.setItem('readNoticeStatus', 1); // 1为已阅读
      this.$router.push({
        path: '/index',
        query: this.$route.query
      });
    },
    countdown() { // 开始倒计时
      this.btnDisabled = true;
      var time = 5;
      var _this = this;
      var timer = setInterval(function () {
        time -= 1;
        _this.readCountdown = time;
        if (time < 1) {
          clearInterval(timer);
          _this.btnDisabled = false;
        }
      }, 1000);
    },
    // 获取配置信息
    getData() {
      // requiredUrls.getConfigurationInformation({
      // },
      //   'GET'
      // ).then(res => {
      //   console.log(res);
      //   if (res.status == '200') {
          let savedConfig = JSON.parse(sessionStorage.getItem('appointmentConfig'));
          let oldReserveDesc = savedConfig.reserveDesc;
          // 把DOM字符串中的所有行内样式：font-size删掉
          // 原因是css外层className即使有!important也无法覆盖子标签的行内样式
          this.reserveDesc = oldReserveDesc.replace(/font-size: .*?;/g, '');
      //   }
      // }).catch(err => {
      //     console.log(err)
      //   });
    },
  },
  mounted() {
    this.getData();
    this.countdown();
  },
}
